import { alpha } from '@mui/material';
import type { FC } from 'react';

import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

const GridDot = styled('div')`
  width: 4px;
  height: 4px;
  background-color: ${alpha(theme.palette.common.white, 0.7)};
  border-radius: 50%;
  transition: background-color 0.2s ease;
`;

const GridContainer = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 2px;
  width: 18px;
  height: 18px;
`;

export const GridIcon: FC = () => {
  return (
    <GridContainer>
      <GridDot />
      <GridDot />
      <GridDot />
      <GridDot />
      <GridDot />
      <GridDot />
      <GridDot />
      <GridDot />
      <GridDot />
    </GridContainer>
  );
};
